import { RefObject, useEffect, useRef } from "react";

export function useHorizontalScroll(): RefObject<HTMLDivElement> {
  const elRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const el = elRef.current;
    if (!el || !el.parentElement) return;

    const parent = el.parentElement;

    const onWheel = (e: WheelEvent) => {
      if (e.deltaY === 0) return;
      e.preventDefault();
      el.scrollTo({
        left: el.scrollLeft + e.deltaY,
        behavior: "smooth",
      });
    };

    const handleResize = () => {
      const parentWidth = parent.clientWidth;
      const elementWidth = el.scrollWidth;

      if (elementWidth > parentWidth) {
        el.addEventListener("wheel", onWheel);
      } else {
        el.removeEventListener("wheel", onWheel);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      el.removeEventListener("wheel", onWheel);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return elRef;
}
